import {useMemo} from 'react';
import {t} from '../../../common/getTranslations';
import {preventDefaultEvent} from '../../../common/shared/utils/preventDefaultEvent.function';
import {twMerge} from '../../../common/twMerge';
import {MOBILE_HEADER_HEIGHT_PX} from '../../../header/constants';
import {Fullscreen} from '../../atoms/Fullscreen/Fullscreen';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {ViewerImagePopupProps} from './ViewerImagePopupProps.interface';

export function ViewerImagePopup({
  isMobile,
  src,
  html,
  className,
  ...props
}: ViewerImagePopupProps) {
  const imgComponent = useMemo(
    () => (
      <>
        {src && (
          <img
            className="h-full w-full object-contain"
            src={src}
            alt="이미지 크게보기"
            onSelect={preventDefaultEvent}
            onDragStart={preventDefaultEvent}
            onContextMenu={preventDefaultEvent}
          />
        )}
        {html && (
          <div
            className="h-full w-full"
            title="이미지 크게보기"
            onSelect={preventDefaultEvent}
            onDragStart={preventDefaultEvent}
            onContextMenu={preventDefaultEvent}
            dangerouslySetInnerHTML={{__html: html}}
          ></div>
        )}
      </>
    ),
    [html, src]
  );

  return (
    <Fullscreen
      className={twMerge('z-100 cursor-pointer', className)}
      {...props}
    >
      {isMobile && (
        <div className="relative h-56pxr shrink-0">
          <div className="absolute top-19pxr right-19pxr z-110">
            <Text className="font-small1 cursor-pointer text-static-mono-10">
              {t('common_close_button')}
            </Text>
          </div>
        </div>
      )}
      {isMobile && (
        <div
          className="relative z-100 w-full"
          style={{
            height: `calc(100% - ${MOBILE_HEADER_HEIGHT_PX}px)`,
          }}
        >
          {imgComponent}
        </div>
      )}
      {!isMobile && (
        <div className="z-100 flex-center-full">
          <div className="relative z-100 max-h-[80vh] max-w-full">
            {imgComponent}
            <Icon
              type={IconType.ButtonCloseSolidMPcStatic}
              className="absolute top-16pxr right-10pxr h-24pxr w-24pxr"
            />
          </div>
        </div>
      )}
      <Fullscreen className="z-0 bg-static-etc-dimmed" />
    </Fullscreen>
  );
}
